import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import css from './all-classes.scss';
import ConnectedLiveMathsLevelPicker from '../../../components/live-maths-level-picker/live-maths-level-picker';
import {
    ALL_CLASSES,
    ALL_YEARS,
    LEVEL
} from '../../../components/report-filters/filter-constants';
import { getTranslationKey } from '../../../helpers/locale-helpers';

const CLASS_ID = 'id';
const CLASS_NAME = 'name';
const Q_PER_MIN = 'questionsPerMinute';
const TOTAL_CORRECT = 'totalCorrect';
const ACCURACY = 'accuracy';
const TOP_SCORE = 'topScore';

const generateColHeader = (mainText, subText) => {
    const i18n = window.i18n;
    return (
        <div className={css['col-header']}>
            <span>{i18n._(mainText)}</span>
            {subText && <span>({i18n._(subText)})</span>}
        </div>
    );
};

const ALL_CLASSES_TABLE_CONFIG = {
    cols: [
        {
            id: CLASS_NAME,
            doTranslation: true,
            name: getTranslationKey(ALL_CLASSES),
            transform: () => getTranslationKey(LEVEL),
            sort: { sortAs: 'string' },
            classes: css.level
        },
        {
            id: Q_PER_MIN,
            headerTransform: () =>
                generateColHeader('Q/MIN', 'Column Header - Avg'),
            transform: () => <ConnectedLiveMathsLevelPicker />,
            colSpan: 4,
            classes: css['level-picker']
        },
        {
            headerTransform: () =>
                generateColHeader(
                    'Column Header - Correct',
                    'Column Header - Total'
                )
        },
        {
            headerTransform: () =>
                generateColHeader(
                    'Column Header - Accuracy',
                    'Column Header - Avg'
                )
        },
        {
            headerTransform: () =>
                generateColHeader(
                    'Column Header - TopScore',
                    'Column Header - Lifetime'
                )
        }
    ],
    nestedData: {
        id: 'classes',
        cols: [
            {
                id: CLASS_NAME,
                truncate: true,
                classes: css['class-name'],
                sort: { sortAs: 'string' },
                onClick: () => null // this is set in the AllClasses component
            },
            { id: Q_PER_MIN },
            { id: TOTAL_CORRECT },
            { id: ACCURACY },
            { id: TOP_SCORE }
        ],
        emptyDataMessage: 'Empty - NoLiveResultsForLevel'
    },
    emptyDataMessage: 'Empty - NoLiveResults',
    defaultSort: CLASS_NAME
};

const ALL_YEARS_TABLE_CONFIG = cloneDeep({
    ...ALL_CLASSES_TABLE_CONFIG,
    defaultSort: CLASS_ID
});
ALL_YEARS_TABLE_CONFIG.cols[0].name = getTranslationKey(ALL_YEARS);
ALL_YEARS_TABLE_CONFIG.cols[0].doTranslation = true;
ALL_YEARS_TABLE_CONFIG.nestedData.cols[0] = {
    ...ALL_YEARS_TABLE_CONFIG.nestedData.cols[0],
    id: CLASS_ID,
    sort: { sortAs: 'number' },
    transform: (row) => row[CLASS_NAME]
};

export {
    ALL_CLASSES_TABLE_CONFIG,
    ALL_YEARS_TABLE_CONFIG,
    Q_PER_MIN,
    CLASS_ID,
    CLASS_NAME
};



// WEBPACK FOOTER //
// ./containers/live-maths/all-classes/all-classes-constants.js